import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { A11yModule } from '@angular/cdk/a11y';

import { AutosuggestComponent } from './autosuggest.component';
import { FormsModule } from '@angular/forms';
import { ClickOutsideDirective } from '../shared-directives/click-outside.directive';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [CommonModule, OverlayModule, A11yModule, FormsModule, MatIconModule],
  declarations: [AutosuggestComponent, ClickOutsideDirective],
  exports: [AutosuggestComponent]
})
export class AutosuggestModule { }
